export default __webpack_public_path__ + "static/media/profil.bfbcb490.png";